import styled from '@emotion/styled';

export const ImportantEventWrapper = styled.div``;
